export function detectVideoPlatform(id: string): 'youtube' | 'vimeo' | 'unknown' {
  if (/^[a-zA-Z0-9_-]{11}$/.test(id) && /[a-zA-Z]/.test(id)) {
    return 'youtube';
  }

  if (/^\d{10,11}$/.test(id)) {
    return 'vimeo';
  }

  return 'unknown';
}

